import React from 'react'
import './style/Header.css'
import { Link } from 'react-router-dom';
function Header(){
    return(
        <div className="myHeader">
          <span className="gmail">anouarsalhi72@gmail.com</span>
          <div className="social">
            <a target="_blank" href="https://www.linkedin.com/in/anouar-salhi-984499216/"><i class="fab fa-linkedin-in"></i></a>
            <a target="_blank" href="https://github.com/AnouarSalhi"><i class="fab fa-github"></i></a>
            <a href="#"><i class="fab fa-twitter"></i></a>
          
            
          </div>
          <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12" style={{wordWrap:"break-word"}}>
                      <p className="hi">Hi, My name is</p>
                      <h1 className="myName">Anouar Salhi.</h1>
                      <h1 className="shortDesc">I build things for <br></br> the web.</h1>
                      <p className="longDesc">I'm a software developer, specializing in building exceptional applications. Currently, I'm focused on building high quality web applications.</p>
                      <div className="center">
                     
                        <Link className="CheckBtn2" to="/projects">View My Work  </Link>
                        <a className="CheckBtn" href="mailto:anouarsalhi72@gmail.com">Get In Touch </a>
                      </div>
                      
                      
                </div>
                <div className="col-md-6 immage">
                      <img className="image" src="./img/header-img.png" alt="Anouar Salhi" title="Anouar Salhi"/>
                </div>

              </div>
          </div>
          <div className="line"></div>
          <div className="hedo">
            <div className="part1">
              
              </div>
            <div className="part2">
             
            </div>
          </div>
          
          
        </div>
    )
}
export default Header;